<template >
    <v-card dark :loading="'teal'" style="width:100%;height:100%;">


    </v-card>

</template>

<script>


    export default {
        name: 'Clean_redirect',
        components: {


        },
        data(){
            return{

            }
        },
        computed:{

        },
        methods:{
            notify:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/notify_spons?';

                let params = 'CAMPAIGN='+"5"+'&REF='+this.$route.query.r;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.send(params);
            }

        },
        mounted:function(){
            document.title="Hihat";
            this.notify();
            window.location.href="https://hpguiden.se/vip-utbildningen/bli-vip-medlem?utm_source=twitch&utm_medium=social&utm_campaign=Ingager&utm_content=twitch"



        }

    }
</script>

<style scoped>

</style>
